<template>
  <v-container fluid class="vendor-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="6" class="d-flex justify-space-between justify-md-start">
              <v-btn to="/vendor/add" color="success" class="button-shadow mr-3">
                <v-icon class="mr-2">mdi-plus</v-icon>
                Add
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              :loading="isReceiving || isDeleting"
              loading-text="Loading... Please wait"
              class="vendors-table"
              show-select
              single-select
              item-key="_id"
              :footer-props="footer"
              :headers="headers"
              :items="[
                ...vendors.filter(vendor=>vendor.vendortype=='Supplier' && vendor.vendorstatus=='Active'),
                ...vendors.filter(vendor=>vendor.vendortype=='Vendor' && vendor.vendorstatus=='Active'),
                ...vendors.filter(vendor=>vendor.vendorstatus!='Active'),
              ]"

              :items-per-page="itemPerPage">
              <template v-slot:top>
                <v-dialog
                  v-model="dialog"
                  width="500"
                >
                  <v-card>
                    <v-card-title>
                      Delete this Vendor?
                    </v-card-title>

                    <v-card-text>
                      {{ deletevendor.vendorname }}
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" outlined @click="dialog = false">Cancel</v-btn>
                      <v-btn color="secondary" class="button-shadow" @click="deleteItem(deletevendor)">Delete</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:item.vendorimage="{ item }">
                  <img v-if="item.vendorimage" v-bind:src="item.vendorimage" alt="" width="80">
              </template>
              <template v-slot:item.vendorname="{ item }">
                <a class="primaryConst--text">{{ item.vendorname }}</a>
                <p>{{ item.vendortype }}</p>
              </template>
              <template v-slot:item.countryid="{ item }">
                <p class="two-line">{{ countries.length>0 && item.countryid!=null ? countries.find(country=>country._id == item.countryid)['countryname'] : ''   }}</p>
              </template>
              <template v-slot:item.vendorstatus="{ item }">
                <v-chip
                  :color="item.vendorstatus=='Active' ? 'success white--text' : item.vendorstatus=='Inactive' ? 'primaryConst white--text' : 'secondaryConst white--text'"
                  small>
                  {{ item.vendorstatus }}
                </v-chip>
              </template>
              <template v-slot:item.createdAt="{ item }">
                {{ new Date(item.createdAt).toLocaleString("en-US", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn icon color="primary" @click="editItem(item)">
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
                <v-btn icon color="primary" @click="deleteDialog(item)">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import config from "../../../config"
import { mapState, mapActions } from 'vuex'

export default {
  name: 'VendorList',
  data() {
    return {
      config,
      snackbar: null,
      dialog: false,
      deletevendor: {},
      headers: [
        { text: 'Image', value: 'vendorimage', sortable: false },
        { text: 'Name', value: 'vendorname' },
        { text: 'Address', value: 'vendoraddress' },
        { text: 'Country', value: 'countryid' },
        { text: 'Status', value: 'vendorstatus' },
        { text: 'Create', value: 'createdAt' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      footer: {'items-per-page-options': [500, 1000, 5000]},
      itemPerPage: 100,
      selected: [],
      switch1: true,

      }
  },

  computed: {
    ...mapState('Vendor', ['vendors', 'isReceiving', 'isDeleting', 'idToDelete', 'vendorsMessage', 'isUpdating']),
    ...mapState('Country', ['countries']),
    formTitle () {
      return this.editedIndex === -1 ? 'New Item' : 'Edit Vendor'
    },
  },

  created () {
    this.getVendorsRequest();
    if(this.countries.length==0) this.getCountriesRequest();
  },

  methods: {
    ...mapActions('Vendor', ["getVendorsRequest","deleteVendorRequest","updateVendorRequest","createVendorRequest"]),
    ...mapActions('Country', ["getCountriesRequest"]),
    editItem(item) {
      this.$router.push({ name: 'VendorEdit', params: item })
    },

    deleteItem(item) {
      this.deleteVendorRequest({_id: item._id});
      this.dialog = false;
    },
    deleteDialog(item) {
      this.dialog = true;
      this.deletevendor = {
        _id: item._id,
        vendorname: item.vendorname,
      }
    },
  },
}
</script>

<style src="./List.scss" lang="scss"></style>
